import type { GeneralConfig } from '@shared/types/Config';

export const userConfig: GeneralConfig = {
    sortFieldMap: {},
};
